<template>
  <div>
    <el-button class="base-margin__bottom-10" type="primary" @click="openDialog">{{
        $t('configManagement.createConfig')
      }}
    </el-button>
    <div class="table">
      <el-table :data="tableData" class="table_width">
        <el-table-column :label="$t('configManagement.id')" prop="id"></el-table-column>
        <el-table-column :label="$t('configManagement.configName')" prop="name"></el-table-column>
        <el-table-column :label="$t('configManagement.configValue')" min-width="200" prop="value"></el-table-column>
        <el-table-column :label="$t('configManagement.description')" prop="describe"></el-table-column>
        <el-table-column :label="$t('configManagement.createTime')" prop="createTime"></el-table-column>
        <el-table-column
          :label="$t('configManagement.actions')"
          width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editImage(scope.row)">{{ $t('configManagement.edit') }}</el-button>
            <el-button type="text" @click="deleteImage(scope.row.id)">{{ $t('configManagement.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="tableDataTotal"
        align="right"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form ref="formLabelAlign" :model="formLabelAlign" label-width="100px">
        <el-form-item :label="$t('configManagement.configName')" prop="name">
          <el-input v-model="formLabelAlign.name" :placeholder="$t('configManagement.enterConfigName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('configManagement.configValue')" prop="value">
          <el-input v-model="formLabelAlign.value" :placeholder="$t('configManagement.enterConfigValue')" rows="5"
                    type="textarea"></el-input>
        </el-form-item>
        <el-form-item :label="$t('configManagement.description')" prop="describe">
          <el-input v-model="formLabelAlign.describe" :placeholder="$t('configManagement.enterDescription')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="createCode">{{ $t('configManagement.confirm') }}</el-button>
  </span>
    </el-dialog>

  </div>
</template>

<script>
import {getRequest, postRequest} from '@/common/libs/request';
import {Message} from 'element-ui';
import {debounce} from '@/common/utils/utils';

export default {
  name: 'configManagement',
  data() {
    return {
      tableData: [], // 配置列表
      dialogTitle: this.$t('configManagement.createConfig'),
      dialogVisible: false,
      formLabelAlign: {
        name: '',
        value: '',
        describe: '',
      },
      dialogType: 'add',
      pageIndex: 1, // 分页index
      pageLimit: 10, // 每一页条数
      tableDataTotal: 0, // 任务总数
    };
  },
  created() {
    this.getList();
  },

  methods: {
    openDialog() {
      this.dialogType = 'add';
      this.dialogTitle = this.$t('configManagement.createConfig');
      this.formLabelAlign = {
        name: '',
        value: '',
        describe: '',
      };
      this.dialogVisible = true;
    },

    /**
     * 获取配置列表
     */
    getList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      getRequest(`/api/eda/common/admin/getSettingList?offset=${offset}&limit=${this.pageLimit}`).then((res) => {
        this.tableData = res.list;
        this.tableDataTotal = res.total;
      });
    },

    /**
     * 创建配置
     */
    createCode() {
      debounce(() => {
        if (this.dialogType === 'add') {
          postRequest('/api/eda/common/admin/createSetting', this.formLabelAlign).then(() => {
            Message.success(this.$t('configManagement.createSuccess'));
            this.dialogVisible = false;
            this.getList();
          });
        } else {
          postRequest('/api/eda/common/admin/updateSetting', this.formLabelAlign).then(() => {
            Message.success(this.$t('configManagement.updateSuccess'));
            this.dialogVisible = false;
            this.getList();
          });
        }
      }, 500);
    },

    /**
     * 编辑配置
     */
    editImage(e) {
      this.dialogTitle = this.$t('configManagement.editConfig');
      this.dialogType = 'edit';
      this.formLabelAlign = Object.assign({}, e);
      this.dialogVisible = true;
    },

    /**
     * 删除配置
     */
    deleteImage(id) {
      this.$confirm(this.$t('configManagement.deleteConfirm'), this.$t('configManagement.deleteConfig'), {
        confirmButtonText: this.$t('configManagement.confirm'),
      }).then(() => {
        postRequest('/api/eda/common/admin/deleteSetting', {id: +id}).then(() => {
          this.getList();
          Message.success(this.$t('configManagement.deleteSuccess'));
        });
      })
        .catch(() => {
          // Message.info('取消删除');
        });
    },
    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.spanCls {
  width: 50px;
  line-height: 40px;
}
</style>
